import * as React from "react";
import useMediaQuery from "@mui/material/useMediaQuery";
import { ThemeProvider, createTheme } from "@mui/material/styles";

import { ColorModeContext } from "context/ColorModeContext";

export default function ThemeManager(props) {
  const prefersDarkMode = useMediaQuery("(prefers-color-scheme: dark)");

  const defTheme =
    localStorage.getItem("theme-mode") || (prefersDarkMode ? "dark" : "light");
  const [mode, setMode] = React.useState(defTheme);
  const colorMode = React.useMemo(
    () => ({
      toggleColorMode: () => {
        setMode((prevMode) => {
          const t = prevMode === "light" ? "dark" : "light";
          localStorage.setItem("theme-mode", t);
          return t;
        });
      },
    }),
    []
  );

  const commonThemProps = {
    spacing: 4,
    typography: {
      fontFamily: [
        "Roboto",
        "system-ui",
        "-apple-system",
        "BlinkMacSystemFont",
        "Segoe UI",
        "Helvetica Neue",
        "Arial",
        "sans-serif",
      ].join(","),
      fontWeightLight: 300,
      fontWeightRegular: 400,
      fontWeightMedium: 500,
      fontWeightBold: 600,
    },
  };

  const getDesignTokens = (mode) => ({
    ...commonThemProps,
    palette: {
      mode,
      ...(mode === "light"
        ? {
            primary: {
              main: "#fb9c00",
              contrastText: "#282727",
            },
            secondary: {
              main: "#575756",
              dark: "#282727",
              light: "#dadada",
            },
          }
        : {
            primary: {
              main: "#fb9c00",
              contrastText: "#282727",
            },
            secondary: {
              main: "#575756",
              dark: "#282727",
              light: "#dadada",
            },
          }),
    },
  });

  const theme = React.useMemo(() => createTheme(getDesignTokens(mode)), [mode]);

  return (
    <ColorModeContext.Provider value={colorMode}>
      <ThemeProvider theme={theme}>{props.children}</ThemeProvider>
    </ColorModeContext.Provider>
  );
}
